import SliderCarousel from "../../components/Carousel.js"

import DATA from "../data/_entity.json"; // assert {type: 'json'}
import SLIDERS from "../data/_sliders.json"; // assert {type: 'json'}
// import loremImage from "../../assets/images/home-side.png"

import "./about.css";


const About = ({ APPDATA }) => {

   return (
      <>

         <div className="home-about" >

            <div className="about-title">
               {APPDATA.pageTitle = APPDATA.TITLE}
               <h4 className="about-suffix" >
                  {DATA.entity.tagline}
               </h4>
            </div>

            <div className="about-description">
               {DATA.entity.description}
            </div>

            <div className="about-carousel">
               <SliderCarousel slides={SLIDERS.sliders.About} options={{ interval: 4000 }} styles={{}} MODE={APPDATA.MODE} />
            </div>

            <div className="about-details">
               {DATA.entity.about}
            </div>
         </div >

      </>
   )
}

export default About;
